import Seo from "@/components/Seo";
import { SEO_META } from "@/data/seo_meta";

// Balises SEO d'une page fixe, à partir de seo_meta.js.
export default function PageSeo({ path, jsonLd }) {
  const meta = SEO_META[path];
  return <Seo title={meta.title} description={meta.desc} path={path} noindex={meta.noindex} jsonLd={jsonLd} />;
}
